import React from 'react';
import Button from 'react-bootstrap/lib/Button';
import Alert from 'react-bootstrap/lib/Alert';
import Field from 'redux-form/lib/Field';
import FieldFormGroup from '../../../FieldFormGroup';
import If from '../../../../shared/If';
import Spinner from '../../../Spinner';
import FieldCardElement from '../FieldCardElement';
import styles from './CreditCardReduxForm.sass';

const CreditCardReduxForm = ({
  anyTouched,
  error,
  isPaymentProcessing,
  selectedProduct,
  submitting,
  buttonLabel = 'Submit',
}) => (
  <div className={styles.root}>
    {anyTouched && error && <Alert bsStyle="danger">{error}</Alert>}
    <Field
      name="name"
      placeholder="Name"
      component={FieldFormGroup}
      type="text"
    />
    <Field
      name="email"
      placeholder="Email"
      component={FieldFormGroup}
      type="email"
    />
    <Field name="token" component={FieldCardElement} />
    <Button
      className={styles.formSubmitButton}
      type="submit"
      bsStyle="primary"
      disabled={submitting || isPaymentProcessing}
    >
      <If
        condition={submitting || isPaymentProcessing}
        ifRender={() => <Spinner size={24} />}
        elseRender={() => buttonLabel}
      />
    </Button>
  </div>
);

export default CreditCardReduxForm;
